import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import {API} from "../../../../config";

import Util from '../../../../util';

const completed_trades = API.service('completed-trades');

const brokers = API.service('authorized-brokers');
const certificates = API.service('certificates');



const styles = theme => ({
    Table:{
        '& td':{
            padding:4,
            textAlign:'right'
        }
    },
    TableHead:{
        background:'black',
        color:'white',
        '& > td':{
            padding:8,
            background:'black',
            color:'white',
            fontWeight:'bold',
            textAlign:'center'
        }
    },
    leftHead:{
      textAlign:'left'
    },
    baseRow:{
        '& > td':{
            background:theme.palette.primary.main,
            color:'white',
            fontWeight:'bold'
        }
    }
});

class Custodian extends Component {
    state = {
        brokers:[],
        buy:{},
        sell:{},
        opening:{},
        internal:{},
    };

    totalOpening = 0;
    totalClosing = 0;

    componentDidMount() {
        const app = this;
        brokers.find({query:{$limit:1000}}).then(b=>{
            app.setState({
                brokers:b.data,
            })
            completed_trades.find({
                query:{
                    _company_account:this.props.company,
                    createdAt:{
                        $gt:this.props.startDate+' 00:00:00',
                        $lt:this.props.endDate+' 23:59:59'
                    },
                    $limit:10000,
                }
            }).then(ct=>{
                let internal={},
                    buy={},
                    sell={},
                    opening={};

                b.data.forEach((bv,iv) => {
                    certificates.find({query:{type:'balance',company_account:this.props.company,startDate:this.props.startDate, broker_id:bv._id}}).then(op=>{
                        console.log(op);
                        if(op.opening === null || typeof op.opening === 'undefined'){
                            opening[bv._id] = 0
                        } else {
                            opening[bv._id] = parseInt(op.opening,10);
                        }

                        if(typeof internal[bv._id] === 'undefined'){
                            internal[bv._id] = 0;
                        }
                        if(typeof buy[bv._id] === 'undefined'){
                            buy[bv._id] = 0;
                        }
                        if(typeof sell[bv._id] === 'undefined'){
                            sell[bv._id] = 0;
                        }

                        app.setState({
                            opening:opening
                        })
                    })
                });
                if(ct.total > 0) {
                    ct.data.forEach((v, i) => {
                        if (typeof internal[v._buying_broker_id] === 'undefined') {
                            internal[v._buying_broker_id] = 0;
                        }
                        if (typeof internal[v._selling_broker_id] === 'undefined') {
                            internal[v._selling_broker_id] = 0;
                        }
                        if (typeof buy[v._buying_broker_id] === 'undefined') {
                            buy[v._buying_broker_id] = 0;
                        }
                        if (typeof buy[v._selling_broker_id] === 'undefined') {
                            buy[v._selling_broker_id] = 0;
                        }
                        if (typeof sell[v._buying_broker_id] === 'undefined') {
                            sell[v._buying_broker_id] = 0;
                        }
                        if (typeof sell[v._selling_broker_id] === 'undefined') {
                            sell[v._selling_broker_id] = 0;
                        }

                        if (v._selling_broker_id !== v._buying_broker_id) {
                            sell[v._selling_broker_id] = sell[v._selling_broker_id] + parseInt(v._quantity,10);
                            buy[v._buying_broker_id] = buy[v._buying_broker_id] + parseInt(v._quantity,10);
                        } else {
                            internal[v._selling_broker_id] = internal[v._selling_broker_id] + parseInt(v._quantity,10);
                        }
                    })
                }
                    app.setState({
                        internal:internal,
                        buy:buy,
                        sell:sell
                    })
            })
        })
    }

    generateTotalOpening = () => {
        let tot = 0;
        this.state.brokers.forEach((v)=>{
            console.log(this.state.opening[v._id])
            tot = tot + this.state.opening[v._id];
        })

        return tot;
    }

    generateTotalClosing = () => {
        let tot = 0;
        this.state.brokers.forEach((v)=>{
            tot = tot + this.state.opening[v._id] + this.state.buy[v._id] - this.state.sell[v._id];
        })

        return tot;
    }

    render() {
        const { classes } = this.props

        return (
            <div className={classes.content} style={{marginTop:10}}>
                <table className={classes.Table} style={{width:'70%'}} cellPadding={0} cellSpacing={0}>
                    <tr className={classes.TableHead}>
                        <td rowSpan={2}>&nbsp;</td>
                        <td rowSpan={2}>Opening Balance</td>
                        <td>Internal Transactions</td>
                        <td colSpan={2}>External Transactions</td>
                        <td rowSpan={2}>Closing Balance</td>
                    </tr>
                    <tr className={classes.TableHead}>
                        <td>Same Broker</td>
                        <td>Acquisitions</td>
                        <td>Disposals</td>
                    </tr>

                    {this.state.brokers.map((v,i)=>{
                        return(
                            <tr key={i}>
                                <td className={classes.leftHead}>{v._name}</td>
                                <td>{(typeof this.state.opening[v._id] === 'undefined') ? 0 : Util.addThousandCommas(this.state.opening[v._id],'0,')}</td>
                                <td>{(typeof this.state.internal[v._id] === 'undefined') ? 0 : Util.addThousandCommas(this.state.internal[v._id],'0,')}</td>
                                <td>{(typeof this.state.buy[v._id] === 'undefined') ? 0 : Util.addThousandCommas(this.state.buy[v._id],'0,')}</td>
                                <td>{(typeof this.state.sell[v._id] === 'undefined') ? 0 : Util.addThousandCommas(this.state.sell[v._id],'0,')}</td>
                                <td>{(typeof this.state.opening[v._id] === 'undefined') ? 0 : Util.addThousandCommas((parseInt(this.state.opening[v._id],10) + parseInt(this.state.buy[v._id],10) - parseInt(this.state.sell[v._id],10)),'0,')}</td>
                            </tr>
                        )
                    })}
                    <tr className={classes.baseRow}>
                        <td className={classes.leftHead}>Totals</td>
                        <td>{Util.addThousandCommas(this.generateTotalOpening(),'0,')}</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>{Util.addThousandCommas(this.generateTotalClosing(),'0,')}</td>
                    </tr>
                    <tr className={classes.baseRow}>
                        <td className={classes.leftHead}>Discrepancy</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>{Util.addThousandCommas(this.generateTotalOpening() - this.generateTotalClosing(),'0,')}</td>
                    </tr>

                </table>
            </div>
        )
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(Custodian));
